/*
* Polls the API until a response returns a status of "DONE" for a given report
* @param {Object} store
* @param {Function} p
* @return void
*/
export function pollReport (store, p = null) {
  if (p) clearTimeout(p)
  const { renderId } = store.getters.getReportRenderStatus
  if (renderId) {
    store.dispatch('fetchRenderedReport')
      .then(r => {
        if (r && r.status && r.status !== 'DONE') {                // if status is not done
          p = setTimeout(() => pollReport(store, p), 2000)    // setTimeout for 2 seconds then call function recursively
        } else {                                              // else stop polling
          store.dispatch('resetReportRenderStatus')
        }
      })
      .catch(e => console.log(e))
  }
}
